/* eslint-disable no-mixed-operators */
import React, { useState, useEffect } from 'react';
import { colors } from './../styles/colors';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { useLocation, useNavigate } from 'react-router-dom';
import we2Blue from '../assets/we2Blue.svg';


const initialTimer = 60;

const Quiz = (props) => {
  const [index, setIndex] = useState(0);
  const [timer, setTimer] = useState(60);
  const location = useLocation();
  const navigate = useNavigate();
  const receivedData = location.state;
  const [questions, setQuestion] = useState(receivedData?.file.data);
  const [isWrongAnswer, setIsWrongAnswer] = useState(false);
  const [score, setScore] = useState(0);
  const [correctAnswer, setCorrectAnswer] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [hasAnswered, setHasAnswered] = useState(false);
  const [wrongAnswers, setWrongAnswers] = useState([]);


  // console.log(questions);
  // console.log(index);
  const currentQuestion = questions[index];

  // console.log(questions[index]);

  // console.log(index);
  // console.log(questions.length);

  useEffect(() => {
    // if (index + 1 === questions.length) {
    //   setQuizCompleted(true);
    // }
    const countdown = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        clearInterval(countdown);
        setIndex(index + 1);
        // setTimer(initialTimer);
      }
    }, 1000);
    const handleKeyDown = (event) => {  

      if(
        event.key === 'Control' || 
        event.key === 'Alt' || 
        event.key === 'Shift' || 
        event.code === 'Space' || 
        event.key === 'Cmd' ||
        event.key === 'Option' ||
        event.key === 'Meta'
        ){
        return;
      }
      if(hasAnswered){
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const isWindows = navigator.platform.toUpperCase().indexOf('WIN') >= 0;
      // for Windows
      if(isWindows){
        const keyName = event.key;
        const ctrl = event.ctrlKey;
        const alt = event.altKey;
        const shift = event.shiftKey;
        const space = event.code === 'Space';
        const ansCtrl = ctrl ? 'Ctrl+' + keyName.toUpperCase() : keyName;
        const ansAlt = alt ? 'Alt+' + keyName.toUpperCase() : keyName;
        const ansShift = shift ? 'Shift+' + keyName.toUpperCase() : keyName;
        const ansSpace = space ? 'Space' : keyName;
        const altPlusCtrl = alt && ctrl ? 'Alt+Ctrl+' + keyName.toUpperCase() : keyName;
        const altPlusShift = alt && shift ? 'Alt+Shift+' + keyName.toUpperCase() : keyName;
        const ctrlPlusShift = ctrl && shift ? 'Ctrl+Shift+' + keyName.toUpperCase() : keyName;
        const altPlusCtrlPlusShift = alt && ctrl && shift ? 'Alt+Ctrl+Shift+' + keyName.toUpperCase() : keyName;
        // if(keyName === 'p'){
        //   console.log('p pressed');
        //   setIndex(index + 1);
        //   // setTimer(initialTimer);
        // }

        if(ctrl && keyName  || alt && keyName || shift && keyName || space || keyName){

          if(
            ansCtrl === currentQuestion.CorrectShortcutWindows ||
            ansAlt === currentQuestion.CorrectShortcutMac ||
            ansShift === currentQuestion.CorrectShortcutWindows ||
            ansSpace === currentQuestion.CorrectShortcutWindows ||
            altPlusCtrl === currentQuestion.CorrectShortcutWindows ||
            altPlusShift === currentQuestion.CorrectShortcutWindows ||
            ctrlPlusShift === currentQuestion.CorrectShortcutWindows ||
            altPlusCtrlPlusShift === currentQuestion.CorrectShortcutWindows ||
            keyName === currentQuestion.CorrectShortcutWindows
            ){
              // console.log('Correct Answer');
              setCorrectAnswer(true);
              setHasAnswered(true);
              // console.log('Correct Answer');
              setScore(score + 5);
              setTimeout(() => {
                setIndex(index + 1);
                // setTimer(initialTimer);
                setCorrectAnswer(false);
                setIsWrongAnswer(false);
                setHasAnswered(false);
                if (index + 1 === questions.length) {
                  setQuizCompleted(true);
                }
              }, 3000);
           
          } 
          // else if(keyName === 'p'){
          //   console.log('p pressed 193');
          //   setIndex(index + 1);
          //   // setTimer(initialTimer);
          // }
          else {
            // console.log('Wrong Answer. Try again.');
            setHasAnswered(true);
            setIsWrongAnswer(true);
            setWrongAnswers([...wrongAnswers, currentQuestion]);
            setTimeout(() => {
              setIndex(index + 1);
              // setTimer(initialTimer);
              setIsWrongAnswer(false);
              setHasAnswered(false);
              setCorrectAnswer(false);
              if (index + 1 === questions.length) {
                setQuizCompleted(true);
              }
            }, 3000);
          } 
        }
        // else if(keyName === 'p'){
        //   // console.log('p pressed 219');
        //   setIndex(index + 1);
        //   if (index + 1 === questions.length) {
        //     setQuizCompleted(true);
        //   }
        //   // setTimer(initialTimer);
        // }
      }
      else if(isMac){  
        // console.log('Inside Mac');
        const keyName = event.key;
        const cmd = event.metaKey;
        const alt = event.altKey;
        const shift = event.shiftKey;
        const space = event.code === 'Space';
        const ansCmd = cmd ? 'Cmd+' + keyName.toUpperCase() : keyName;
        const ansAlt = alt ? 'Alt+' + keyName.toUpperCase() : keyName;
        const ansShift = shift ? 'Shift+' + keyName.toUpperCase() : keyName;
        const ansSpace = space ? 'Space' : keyName;
        const altPlusCmd = alt && cmd ? 'Alt+Cmd+' + keyName.toUpperCase() : keyName;
        const altPlusShift = alt && shift ? 'Alt+Shift+' + keyName.toUpperCase() : keyName;
        const cmdPlusShift = cmd && shift ? 'Cmd+Shift+' + keyName.toUpperCase() : keyName;
        const altPlusCmdPlusShift = alt && cmd && shift ? 'Alt+Cmd+Shift+' + keyName.toUpperCase() : keyName;

        if(cmd && keyName  || alt && keyName || shift && keyName || space || keyName){
          if(
            ansCmd === currentQuestion.CorrectShortcutMac_1  ||
            ansAlt === currentQuestion.CorrectShortcutMac_1 ||
            ansShift === currentQuestion.CorrectShortcutMac_1 ||
            ansSpace === currentQuestion.CorrectShortcutMac_1 ||
            altPlusCmd === currentQuestion.CorrectShortcutMac_1 ||
            altPlusShift === currentQuestion.CorrectShortcutMac_1 ||
            cmdPlusShift === currentQuestion.CorrectShortcutMac_1 ||
            altPlusCmdPlusShift === currentQuestion.CorrectShortcutMac_1 ||
            keyName === currentQuestion.CorrectShortcutMac_1
            ){
              // console.log('Correct Answer');
              setCorrectAnswer(true);
              setHasAnswered(true);
              // console.log('Correct Answer');
              setScore(score + 5);
              setTimeout(() => {
                setIndex(index + 1);
                // setTimer(initialTimer);
                setCorrectAnswer(false);
                setHasAnswered(false);
                setIsWrongAnswer(false);
                if (index + 1 === questions.length) {
                  setQuizCompleted(true);
                }
              }, 3000);
           
          } 
          // else if(keyName === 'p'){
          //   setIndex(index + 1);
          //   if (index + 1 === questions.length) {
          //     setQuizCompleted(true);
          //   }
          //   // setTimer(initialTimer);
          // }
          else {
            // console.log('Wrong Answer. Try again.');
            setIsWrongAnswer(true);
            setHasAnswered(true);
            setWrongAnswers([...wrongAnswers, currentQuestion]);
            setTimeout(() => {
              setIndex(index + 1);
              // setTimer(initialTimer);
              setIsWrongAnswer(false);
              setCorrectAnswer(false);
              setHasAnswered(false);
              if (index + 1 === questions.length) {
                setQuizCompleted(true);
              }
            }, 3000);
          }
        }else if(keyName === 'p'){
          // console.log('p pressed 219');
          setIndex(index + 1);
          // setTimer(initialTimer);
        }

      }
    };
    

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      // window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('keydown', handleKeyDown);
      clearInterval(countdown);
    };
  }, [questions, index, score, timer, currentQuestion, wrongAnswers]);

  useEffect(() => {
    if (quizCompleted || timer === 0) {
      // Navigate to the next screen or perform your desired action
      navigate('/result' , {
        state: { 
          wrongAnswers: wrongAnswers , 
          score: score,
          toolName : receivedData?.file?.data[0]?.ToolName,
        }});
    }
  }, [navigate, quizCompleted, score, timer, wrongAnswers]);

  const timerPercentage = (timer / initialTimer) * 100;


  return (
    <div className='mx-auto flex flex-col w-screen h-screen' style={{ backgroundColor: isWrongAnswer ? colors.darkGrey : colors.primaryColor }}
    >
      <h1
        className='mt-20  text-xl md:text-2xl lg:text-2xl xl:text-2xl text-center'
        style={{ 
            color: isWrongAnswer ? colors.primaryColor : colors.darkGrey ,
            // fontSize: 'clamp(1.875rem, 0.5106rem + 4.3662vw, 5.75rem)',
              
          }}
      >
        Keyboard Shortcut Tester
        <span className='text-xl  ml-6 font-light'>
          {receivedData?.file?.data[0]?.ToolName}
        </span>
      </h1>
      <div className='mt-12 sm:mt-10 md:mt-12 lg:mt-12 flex justify-between mx-auto  w-[70%]'>
        <h1 
        style={{
          color: colors.darkGrey,
        }}
        className='mb-4 text-xl sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl'>Score: <span>{
          score
        }</span></h1>
        <Box sx={{ width: '100%' }} className="mt-6">
          <LinearProgress
            sx={{
              backgroundColor: isWrongAnswer ? colors.primaryColor : colors.darkGrey,
              '& .MuiLinearProgress-bar': {
                backgroundColor: colors.secondaryColor,
              },
              height: '20px',
            }}
            variant='determinate'
            value={timerPercentage}
          />
        </Box>

      </div>
      {/* question div */}
      {correctAnswer && (
        <h6 className='text-4xl text-center' style={{ color: colors.secondaryColor }}>
          CORRECT!
        </h6>
      )}
      {isWrongAnswer && (
        <h6 className='text-4xl text-center' style={{ color: colors.secondaryColor }}>
          INCORRECT!
        </h6>
      )}
      <div className="flex justify-center mt-32 h-[45%]">

        <h6 className='text-6xl' style={{ color: colors.secondaryColor }}>
          {questions[index]?.Feature}
        </h6>
      </div>
      <div className="mx-auto  w-[70%] ">
        {/* <div className=''> */}
          <h2  style={{
            color: isWrongAnswer ? colors.primaryColor : colors.darkGrey,
          }} className="text-center  text-xl">press the correct shortcut
            {/* <span
              className='ml-4 font-light'
              style={{
                color: isWrongAnswer ? colors.primaryColor : colors.black,
              }}>
              or press ‘p’ to pass
            </span> */}
            </h2>
        {/* </div> */}
      </div>
      <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
        <img src={we2Blue} alt="keyboard" sx={{
          width: '156px',
          height: '117px',
        }} />
      </div>
    </div>

  );
};

export default Quiz;
